module.exports = __webpack_public_path__ + "img/87a0caa.svg";